import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Spinner, Card, Button, Row, Col } from "react-bootstrap";

const Audit = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const userId = localStorage.getItem("customer_id");

    const pdfLinks = {
        "Audit Your Life, Business & Income": "https://drive.google.com/file/d/LIFE_BUSINESS_INCOME/view",
        "Audit Your Income": "https://drive.google.com/file/d/INCOME/view",
        "Audit Your Life": "https://drive.google.com/file/d/LIFE/view",
        "Audit Your Business": "https://drive.google.com/file/d/BUSINESS/view",
    };

    useEffect(() => {
        const fetchOrders = async () => {
            if (!userId) {
                console.error("User ID not found in localStorage.");
                setLoading(false);
                return;
            }

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}/orders?customer_id=${userId}`
                );

                const auditOrders = (response.data.data || []).filter(
                    (order) =>
                        order.status === "completed" &&
                        order.service_name === "Audit" &&
                        pdfLinks[order.package_type]
                );

                setOrders(auditOrders);
            } catch (error) {
                console.error("Error fetching audit orders:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [userId]);

    return (
        <Container className="my-5">
            <h2 className="mb-4 text-center">My Audit Reports</h2>

            {loading ? (
                <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                </div>
            ) : orders.length === 0 ? (
                <p className="text-muted text-center">No completed Audit orders found.</p>
            ) : (
                <Row className="g-4">
                    {orders.map((order) => (
                        <Col key={order.order_id} md={6} lg={4}>
                            <Card className="h-100 shadow-sm border-0 rounded-4">
                                <Card.Body className="d-flex flex-column justify-content-between">
                                    <div>
                                        <h5 className="text-primary fw-bold">{order.package_type}</h5>
                                        <p className="text-muted mb-3">{order.service_name}</p>
                                    </div>

                                    <Button
                                        variant="success"
                                        size="lg"
                                        className="w-100 mt-3"
                                        href={pdfLinks[order.package_type]}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Download PDF
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}
        </Container>
    );
};

export default Audit;
